var _g, _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_568_5060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0.375H11.0938L17.125 6.40625V18C17.125 18.8975 16.3975 19.625 15.5 19.625H4.5C3.60254 19.625 2.875 18.8975 2.875 18V2C2.875 1.10254 3.60254 0.375 4.5 0.375Z",
    fill: "white",
    stroke: "#C8D2E1",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 0.5V5C11 5.82843 11.6716 6.5 12.5 6.5H17",
    stroke: "#C8D2E1",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 9.5,
    width: 12,
    height: 8,
    rx: 1,
    fill: "#0DB664"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.44014 15.5L2.47514 13.595L1.49514 11.795H2.32014L2.69014 12.565C2.73347 12.6483 2.7768 12.7383 2.82014 12.835C2.86347 12.9283 2.9118 13.0317 2.96514 13.145H2.98514C3.0318 13.0317 3.07514 12.9283 3.11514 12.835C3.15514 12.7383 3.19514 12.6483 3.23514 12.565L3.58514 11.795H4.36514L3.39014 13.625L4.43014 15.5H3.61014L3.19514 14.68C3.1518 14.5867 3.10514 14.49 3.05514 14.39C3.00847 14.29 2.95847 14.1833 2.90514 14.07H2.88514C2.83847 14.1833 2.79347 14.29 2.75014 14.39C2.7068 14.49 2.6618 14.5867 2.61514 14.68L2.22014 15.5H1.44014ZM4.8549 15.5V11.795H5.5949V14.88H7.0999V15.5H4.8549ZM8.57475 15.57C8.32808 15.57 8.08641 15.5233 7.84975 15.43C7.61308 15.3367 7.40475 15.2033 7.22475 15.03L7.64975 14.52C7.77975 14.6433 7.92808 14.7433 8.09475 14.82C8.26475 14.8933 8.42975 14.93 8.58975 14.93C8.78308 14.93 8.92975 14.8917 9.02975 14.815C9.12975 14.7383 9.17975 14.635 9.17975 14.505C9.17975 14.4117 9.15475 14.3383 9.10475 14.285C9.05808 14.2283 8.99308 14.1783 8.90975 14.135C8.82641 14.0917 8.72975 14.0483 8.61975 14.005L8.12975 13.79C8.00641 13.74 7.88641 13.6733 7.76975 13.59C7.65641 13.5033 7.56141 13.395 7.48475 13.265C7.41141 13.135 7.37475 12.98 7.37475 12.8C7.37475 12.5967 7.42975 12.415 7.53975 12.255C7.64975 12.095 7.80141 11.9683 7.99475 11.875C8.18808 11.7783 8.40808 11.73 8.65475 11.73C8.87475 11.73 9.08641 11.7717 9.28975 11.855C9.49308 11.9383 9.66975 12.0567 9.81975 12.21L9.44475 12.67C9.32808 12.5733 9.20641 12.4983 9.07975 12.445C8.95308 12.3917 8.81141 12.365 8.65475 12.365C8.49475 12.365 8.36641 12.4 8.26975 12.47C8.17641 12.5367 8.12975 12.6317 8.12975 12.755C8.12975 12.8417 8.15641 12.9133 8.20975 12.97C8.26308 13.0267 8.33308 13.0767 8.41975 13.12C8.50641 13.16 8.60141 13.2017 8.70475 13.245L9.18975 13.44C9.33975 13.5 9.46975 13.575 9.57975 13.665C9.69308 13.755 9.77975 13.8633 9.83975 13.99C9.90308 14.1167 9.93475 14.27 9.93475 14.45C9.93475 14.65 9.87975 14.835 9.76975 15.005C9.66308 15.175 9.50808 15.3117 9.30475 15.415C9.10475 15.5183 8.86141 15.57 8.57475 15.57Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_568_5060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 20,
    fill: "white",
    transform: "translate(2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsIcon);
export default __webpack_public_path__ + "static/media/xls-icon.ad7c3d937f7a06af518267e49d8d7f71.svg";
export { ForwardRef as ReactComponent };